(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('facility-phone-number', {
                parent: 'entity',
                url: '/facility-phone-number',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM, ROLES.ROLE_SYSTEM_ADMIN],
                    pageTitle: 'FacilityPhoneNumbers'
                },
                ncyBreadcrumb: {
                    label: 'Facility Phone Numbers',
                    parent: 'entity'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facility-phone-number/list/facility-phone-number.html',
                        controller: 'FacilityPhoneNumberController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();
